import { Component, Vue } from 'vue-property-decorator';
import WithRender from './AgentProductReport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading
  }
})
export default class AgentProductReport extends Vue {
  isLoading = false;

  userId = '';
  fullName = '';
  dateFrom = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10);
  dateTo = new Date().toISOString().substr(0, 10);
  success = 'true';

  perPage = 100;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  items = [];
  fields = [
    { key: "product",      label: "Product",      sortable: true },
    { key: "transactions", label: "Transactions", sortable: true },
    { key: "amount",       label: "Amount",       sortable: true },
    { key: "discount",     label: "Discount",     sortable: true },
  ];

  successOptions = [
    { value: 'true', text: 'Successful' },
    { value: 'false', text: 'Failed' },
  ];

  mounted() {
    this.userId = (this.$route.query.userId as string) || '';
    this.fullName = (this.$route.query.fullName as string) || '';
    if (this.userId) {
      this.getReport();
    }
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getReport();
  }

  getReport(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/ProductReport/ByAgent?dateFrom=${this.dateFrom}&dateTo=${this.dateTo}&currentPage=${this.currentPage}&pageSize=${this.perPage}&success=${this.success}&userId=${this.userId}`)
      .then(response => {
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

  goBack(): void {
    this.$router.push('/agentmonthlysales');
  }
}
